import { APIClient } from "api/api_helper";
import { VERIFICATION_QUEUE_API, SESSION_API } from "api/url_helper";


const api = new APIClient();

export const verificationApiService = {
  getSelectAllData: (studyid: number | null = null) => {
    return api.create(VERIFICATION_QUEUE_API.VERIFICATION_QUEUE_API + "SelectAll", { studyid });
  },

  getNotificationCount: (studyid: number | null = null) => {
    const payload = {
      studyid: studyid,
    };
    return api.create(VERIFICATION_QUEUE_API.NOTIFICATION_COUNT_API + "Count", payload);
  },

  getSampleCollectionData: (studyid: number, periodid: number) => {
    return api.create(VERIFICATION_QUEUE_API.NOTIFICATION_COUNT_API + "samplecollection", { studyid, periodid });
  },

  globalVerify: (payload: {
    studyid: number;
    periodid: number;
    verifiedby: number;
    verifypin: string;
  }) => {
    return api.create(SESSION_API.SAMPLE_COLLECTION_TIME_API + "GlobalVerify", payload);
  },
};
